import client, { TOKEN_KEY } from './client';

export interface AuthUser {
  username:    string;
  role:        string;
  permissions: string[];
}

interface LoginResponse extends AuthUser {
  token: string;
}

export const login = async (username: string, password: string): Promise<AuthUser> => {
  const { data } = await client.post<{ data: LoginResponse }>('/auth/login', { username, password });
  const { token, ...user } = data.data;
  localStorage.setItem(TOKEN_KEY, token);
  return user;
};

export const logout = async (): Promise<void> => {
  try {
    await client.post('/auth/logout');
  } finally {
    localStorage.removeItem(TOKEN_KEY);
  }
};

/** Returns user from the stored bearer token, or null if not authenticated. */
export const getMe = async (): Promise<AuthUser | null> => {
  try {
    const { data } = await client.get<{ data: AuthUser }>('/auth/me');
    return data.data;
  } catch {
    return null;
  }
};
